<template>
    <div class="device-props-component">
        <b-container class="full-height" fluid>
            <div class="content-container">
                <div class="settings-container bg-dark h-100 mr-3 expanded">
                    <div class="settings">
                        <b-form class="inline-form p-2">
                            <div class="inline-form-group">
                                <label for="deviceSelect">
                                    {{$t('monitoring.history.device')}}
                                </label>
                                <div class="inline-form-input">
                                    <Loader v-if="!deviceList.length" />
                                    <b-form-select
                                        v-once
                                        v-if="!!deviceList.length"
                                        class="inline-form-input"
                                        id="deviceSelect"
                                        v-model="selectedDevice"
                                        :dark="true"
                                    >
                                        <b-form-select-option v-bind:key="item.id" v-for="item in deviceList" :value="item">
                                            {{item.name}}
                                        </b-form-select-option>
                                    </b-form-select>
                                </div>
                            </div>
                        </b-form>
                    </div>
                </div>
                <div class="props-container">
                    <h5 v-if="!selectedDevice">{{$t('monitoring.props.select_device')}}</h5>
                    <b-tabs v-if="selectedDevice" content-class="mt-3" class="props-chapter" dark>
                        <b-tab :title="$t('monitoring.props.general')" active dark>
                            <GeneralProps
                                :device-id="selectedDevice.id"
                            />
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </b-container>
    </div>

</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import Loader from "../../Common/Loader.vue";
import GeneralProps from "./GeneralProps.vue";
import DeviceGroupRepository from "../../../Repository/DeviceGroup/DeviceGroupRepository";
import {IDeviceDto} from "../../../Repository/DeviceGroup/Dto/IDeviceDto";

@Component({
    components: { Loader, GeneralProps },
    props: {
        deviceId: { type: Number, required: false, }
    }
})
class DeviceProps extends Vue {
    selectedDevice: IDeviceDto | null = null;
    deviceList: IDeviceDto[] = [];

    mounted() {
        this.loadDeviceList();
    }

    loadDeviceList() {
        const that = this;
        DeviceGroupRepository
            .getAllDevicesWithGroups(this.$store)
            .then(response => {
                this.deviceList = response;
                if (this.deviceList?.length) {
                    let device: IDeviceDto|undefined;
                    if (that.$route.params.deviceId) {
                        const needleId = Number.parseInt(that.$route.params.deviceId);
                        device = that.deviceList.find(q => q.id === needleId);
                    }
                    this.selectedDevice = device ?? this.deviceList[0];
                }
            });
    }
}

export default DeviceProps;
</script>

<style lang="scss">
    @import '../../../custom1';

    .device-props-component {
        .full-height {
            height: calc(100vh - 64px);
        }

        .content-container {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            height: 99%;

            .settings-container {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
                position: relative;
                margin-left: -1em;

                &.expanded {
                    flex: 0 0 25%;
                    max-width: 25%;
                }

                .inline-form {
                    display: flex;
                    flex-direction: column;

                    .inline-form-group {
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        margin-bottom: 1em;

                        label {
                            min-width: 25%;
                            margin-right: 0.5em;
                        }

                        .inline-form-input {
                            flex-grow: 1;
                            display: flex;

                            * {
                                margin-right: 0.5em;

                                &:last-child {
                                    margin-right: 0;
                                }
                            }


                            .b-calendar-grid-body {
                                span {
                                    color: white !important;

                                    &:hover {
                                        color: $dark !important;
                                    }
                                }
                            }

                            .dropdown-menu {
                                background-color: $dark;
                            }
                        }
                    }
                }

                .header-bar {
                    background-color: lighten($dark, 15%);
                    padding: 0.25em;
                    text-align: center;
                    margin: 0 -1em 0 -1em;
                }

                .settings {
                    padding: 0.5em;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;

                    .group {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;

                        .label {
                            min-width: 30%;
                            display: block;
                            text-align: end;
                            margin-right: 1em;
                        }
                    }

                    .track-list {
                        height: calc(100% - 2.5em);
                        overflow: hidden auto;
                        color: white;

                        .track-list-row {
                            display: flex;
                            width: 100%;

                            .item-text {
                                display: flex;
                                flex-direction: column;
                                justify-content: flex-start;
                                align-items: flex-start;
                                padding: 0.25em 0;

                                &.trip {
                                    justify-content: space-between;
                                    flex-direction: row;
                                }

                                &.track {
                                    & > * {
                                        &.date-interval {
                                            color: darkgray;
                                        }

                                        display: flex;
                                        flex-direction: row;

                                        & > * {
                                            margin-right: 1em;

                                            &:last-child {
                                                margin-right: 0;
                                            }
                                        }
                                    }
                                }

                                .date-interval > * {
                                    font-size: 0.95em;
                                    line-height: 1em;
                                }

                                .trip-color {
                                    width: 1em;
                                    height: 1em;
                                }
                            }
                        }
                    }
                }

                .footer {
                    width: 100%;
                    white-space: nowrap;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    align-items: flex-end;
                    cursor: pointer;
                    padding: 1em;

                    &:hover {
                        background-color: lighten($dark, 10%);
                    }
                }
            }

            .props-container {
                width: 100%;

                .props-chapter {
                    .nav-tabs {
                        border-bottom: 1px solid $dark;

                        .nav-link {
                            color: white;
                            border: none;
                            border-radius: 0;

                            &.active {
                                background-color: $dark;
                                border-color: $dark;
                            }
                        }
                    }
                }
            }
        }
    }
</style>